/* eslint-disable @typescript-eslint/no-empty-function */
import { DashboardCard, H2, P } from 'styling/GlobalStyles'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { IWidget } from 'types/dashboard.interface'
import { BodyText, TitleText } from 'styling/Typography'
import { WidgetEditOverlay } from 'pages/Dashboard/Dashboard.styled'
import { HrDashboardInnerWidgetContainer, HrDashboardTitleLine } from '../HrDashboard.styled'
import { attendanceTypesOptions } from 'pages/Attendance/data'
import { useSelector } from 'react-redux'
import { RootState } from 'store'

export const AttendanceWidget = ({
    modalOpen,
    removeWidget,
    onDragOver,
    onDragStart,
    onDragDrop
}: IWidget) => {

    const { attendanceSummary } = useSelector((state: RootState) => state.hrDashboard)

    const getValue = c => {
        const s = c.split('Color')[0]
        return attendanceSummary ? attendanceSummary[s] : 0
    }

    return (
        <DashboardCard
            draggable={modalOpen}
            onDragStartCapture={() => {
                onDragStart('attendance', 1)
            }}
            onDrop={onDragDrop}
            onDragEnd={(e) => {
                e.preventDefault()
            }}
            onDragOver={(e) => {
                e.preventDefault()
                onDragOver('attendance')
            }}
            width='1fr'
            style={{ gridArea: 'attendance', cursor: modalOpen ? 'grab' : 'normal' }}
        >
            {modalOpen && (
                <WidgetEditOverlay
                    onClick={(e) => {
                        removeWidget('attendance')
                        e.stopPropagation()
                    }}
                >
                    <P>Remove Widget</P>
                    <CloseIcon />
                </WidgetEditOverlay>
            )}
            <TitleText weight='bold'>ATTENDANCE</TitleText>
            <HrDashboardTitleLine>
                <BodyText>
                    Total present today
                </BodyText>
                <H2 style={{ fontSize: 24, color: '#ff9900' }} >
                    {attendanceSummary?.present || 0}
                </H2>
            </HrDashboardTitleLine>
            <HrDashboardInnerWidgetContainer>
                {attendanceTypesOptions.filter(a => a.label !== 'Present').map(a => <HrDashboardTitleLine marginTop='13px' smallPaddingBottom key={a.value} >
                    <BodyText>
                        {a.label}
                    </BodyText>
                    <TitleText weight='bold' >
                        {getValue(a.color)}
                    </TitleText>
                </HrDashboardTitleLine>)}
                <HrDashboardTitleLine marginTop='13px' smallPaddingBottom  >
                    <BodyText>
                        Unassigned
                    </BodyText>
                    <TitleText weight='bold' >
                        {attendanceSummary?.unassigned}
                    </TitleText>
                </HrDashboardTitleLine>
            </HrDashboardInnerWidgetContainer>

        </DashboardCard>
    )
}
